// extracted by mini-css-extract-plugin
module.exports = {"opcoes":"Opcoes_opcoes__3apPW"};